/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

$(window).load(function () {
  if ($(".flexslider").length) {
    $(".flexslider").flexslider({
      pauseOnHover: true,
      slideshowSpeed: parseInt($(".slides-speed").attr("data-speed")),
    });
  }

  if ($(".flexslider-pecas").length) {
    $(".flexslider-pecas").flexslider({
      slideshow: true,
      slideshowSpeed: 4000,
    });
  }
  $(".featherlight-products").featherlightGallery({
    previousIcon: "«",
    nextIcon: "»",
    galleryFadeIn: 300,

    openSpeed: 300,
  });

  $('[data-toggle="tooltip"]').tooltip();

  $(".selectpicker").selectpicker();

  $("input, textarea").placeholder();

  $("img[data-src-hover]").hover(
    function () {
      $(this).attr("src", $(this).data("src-hover"));
    },
    function () {
      $(this).attr("src", $(this).data("src-original"));
    }
  );

  $(".marcas-scroller").simplyScroll({ speed: 4 });

  $(".categorias>li>a").click(function () {
    if ($(this).parent().hasClass("active")) {
      $(this).parent().parent().find("li.active ul").slideUp();
      $(this).parent().parent().find("li.active").removeClass("active");
    } else {
      $(this).parent().parent().find("li.active ul").slideUp();
      $(this).parent().parent().find("li.active").removeClass("active");
      $(this).parent().find("ul").slideDown();
      $(this).parent().addClass("active");
    }
    return false;
  });

  $(".produtos-categorias-especiais-sub-nav").hover(
    function () {
      $(this)
        .find("img")
        .attr("src", $(this).find("img").attr("data-src-hover"));
    },
    function () {
      $(this)
        .find("img")
        .attr("src", $(this).find("img").attr("data-src-default"));
    }
  );

  $(".produtoQuickAdd, .produtoAdd, .produto-col-add").click(function () {
    var url = $(this).attr("href");
    var quantidade = 1;
    var referencia_opcao = "";

    if ($(this).parent().find(".produtoQuantidadeAdd").val() !== 0) {
      quantidade = $(this).parent().find(".produtoQuantidadeAdd").val();
    }

    if ($(this).parent().find(".produtoOptionAdd").val() !== 0) {
      referencia_opcao = $(this).parent().find(".produtoOptionAdd").val();
    }

    $.getJSON(
      url,
      {
        quantidade: quantidade,
        referencia_opcao: referencia_opcao,
        format: "json",
        hash: new Date().getTime(),
      },
      function (result) {
        $(".carrinhoTotalEuro").html(result.total_euro);
        $(".carrinhoTotalItems").html(result.total_items);

        $modalWrapper = $("#modalCarrinhoAdicionado");

        var unidadesText = "Unidade";

        if (result.produto_quantidade > 1) {
          unidadesText = "Unidades";
        }

        $modalWrapper.find(".mCAReferencia").html(result.produto_referencia);
        $modalWrapper.find(".mCATitulo").html(result.produto_titulo);
        $modalWrapper.find(".mCAPreco").html(result.produto_preco + " €");
        $modalWrapper
          .find(".mCAQuantidade")
          .html(result.produto_quantidade + " " + unidadesText);
        $modalWrapper.find(".mCAImagem").attr("src", result.produto_imagem);

        $modalWrapper.modal("show");
      }
    );

    return false;
  });

  $(".finalizarClientesList").change(function () {
    window.location = "/carrinho/finalizar?cliente_id=" + $(this).val();
  });

  $(".form-finalizar").submit(function () {
    $(".btn-finalizar-encomenda").prop("disabled", true);
  });

  $(".carrinho-matricula").popover("show");

  $(".produtoGetQuote").click(function () {
    $modalWrapper = $(".modalProdutoQuote");
    $modalWrapper.find("form").show();
    $modalWrapper.find(".sucesso").hide();
    $(".modalProdutoQuote").modal().show();
  });

  $(".modalProdutoQuote button").click(function () {
    $modalWrapper = $(".modalProdutoQuote");
    var url = $modalWrapper.find("form").attr("action");
    var nome = $modalWrapper.find("input.nome").val();
    var email = $modalWrapper.find("input.email").val();
    var telefone = $modalWrapper.find("input.telefone").val();

    if (email !== "" || telefone !== "") {
      $.getJSON(
        url,
        {
          nome: nome,
          email: email,
          telefone: telefone,
          format: "json",
          hash: new Date().getTime(),
        },
        function (result) {
          if (result.mensagem === "Sucesso") {
            $modalWrapper.find("form").hide();
            $modalWrapper.find(".sucesso").show();
          }
        }
      );
    } else {
      alert("Tem preencher um dos seguintes campos: Email ou Telefone");
    }
    return false;
  });

  $(".produtoResellerGetQuote").click(function () {
    $modalWrapper = $(".modalResellerProdutoQuote");
    $modalWrapper.find(".reseller-stock").html("");
    $modalWrapper.find(".reseller-pvp").html("");
    $modalWrapper.find(".reseller-desconto").html("");
    $modalWrapper.find(".reseller-marca").html("");
    $modalWrapper.find(".reseller-peso").html("");
    $modalWrapper.find(".reseller-reclamadas").html("");
    $modalWrapper.find(".reseller-quote-response-container").hide();
    $(".modalResellerProdutoQuote").modal().show();
  });

  $(".modalResellerProdutoQuote button").click(function () {
    $modalWrapper = $(".modalResellerProdutoQuote");
    var url = $modalWrapper.find("form").attr("action");
    var quantidade = $modalWrapper.find("input.quantidade").val();

    if (quantidade !== "" && quantidade > 0) {
      $.getJSON(
        url,
        { quantidade: quantidade, format: "json", hash: new Date().getTime() },
        function (result) {
          if (result.mensagem === "Sucesso") {
            $modalWrapper.find(".reseller-stock").html(result.disponibilidade);
            $modalWrapper.find(".reseller-pvp").html(result.pvp);
            $modalWrapper.find(".reseller-desconto").html(result.desconto);
            $modalWrapper.find(".reseller-marca").html(result.marca);
            $modalWrapper.find(".reseller-peso").html(result.peso);
            $modalWrapper.find(".reseller-reclamadas").html(result.reclamadas);
            $modalWrapper.find(".reseller-quote-response-container").show();
          }
        }
      );
    } else {
      alert("Tem preencher a Quantidade.");
    }
    return false;
  });

  $(".tabRevenda").click(function () {
    var referencia = $(this).attr("data-referencia");

    $.getJSON(
      "/produtos/revendalog/" + referencia,
      { format: "json", hash: new Date().getTime() },
      function (result) {}
    );
  });

  $(".apoio-pergunta").click(function () {
    $(this).toggleClass("active");
    $(this).parent().parent().find(".apoio-resposta").slideToggle();
    return false;
  });

  $(".viaturaAdd").click(function () {
    var titulo = $(".viaturasNovaTitulo").val();
    var quadro = $(".viaturasNovaQuadro").val();
    var url = $(this).attr("href");
    if (titulo.trim() !== "" && quadro.trim() !== "") {
      $.getJSON(
        url,
        {
          titulo: titulo,
          quadro: quadro,
          format: "json",
          hash: new Date().getTime(),
        },
        function (result) {
          if (result.mensagem === "sucesso") {
            window.location.reload();
          } else {
            alert("Ocorreu um erro. \nPor favor tente mais tarde.");
          }
        }
      );
    }
    return false;
  });

  $(".viaturaRemove").click(function () {
    var url = $(this).attr("href");
    $.getJSON(
      url,
      { format: "json", hash: new Date().getTime() },
      function (result) {
        console.log(result.mensagem);
        if (result.mensagem === "sucesso") {
          window.location.reload();
        } else {
          alert("Ocorreu um erro. \nPor favor tente mais tarde.");
        }
      }
    );
    return false;
  });

  $(".modalClienteSubscreverNewsletter form").submit(function () {
    var url = $(".modalClienteSubscreverNewsletter form").attr("action");

    $.getJSON(
      url,
      {
        hash: new Date().getTime(),
        format: "json",
        customer_newsletter: $(
          ".modalClienteSubscreverNewsletter form .customer_newsletter"
        ).is(":checked"),
      },
      function (result) {
        if (result.status === true) {
          $(".modalClienteSubscreverNewsletter").modal("hide");
        }
      }
    );

    return false;
  });

  $(".dadosClienteCopiarMoradas").click(function () {
    if ($(this).is(":checked")) {
      $(".moradae").val($(".moradaf").val());
      $(".moradaeCodigoPostal").val($(".moradafCodigoPostal").val());
      $(".moradaeLocalidade").val($(".moradafLocalidade").val());
      $(".moradaeRegiao").val($(".moradafRegiao").val());
    }
  });

  if ($(".form-newsletter-sidebar").length) {
    var date = new Date();
    var year = date.getFullYear();

    $(".form-newsletter-sidebar [type=hidden]").val(year);
  }

  if ($(".modalEnviosInternacionais").length) {
    $.getJSON(
      "https://freegeoip.net/json/",
      { hash: new Date().getTime() },
      function (result) {
        if (result.country_code === "BR") {
          $(".modalEnviosInternacionais").modal().show();
        }
      }
    );
  }

  if ($(".modalClienteSubscreverNewsletter").length) {
    $(".modalClienteSubscreverNewsletter").modal().show();
  }

  $(".modal-support-icon").click(function () {
    //$('.modal-support-window').show();
    $(".modal-support-window").addClass("modal-support-window__move");
    //$('.modal-support-icon').hide();
    $(".modal-support-icon-wrapper").addClass(
      "modal-support-icon-wrapper__move"
    );
    $(".modal-support-window .alert-success").hide();
    return false;
  });

  $(".areaClienteEncomendaObsPrivadasOpenModal").click(function (e) {
    e.preventDefault();
    $(".modalAreaClienteEncomendaObsPrivadas").modal().show();
  });

  $(".modalAreaClienteEncomendaObsPrivadas .btn-action").click(function (e) {
    e.preventDefault();

    $modalWrapper = $(".modalAreaClienteEncomendaObsPrivadas form");

    $.ajax({
      context: this,
      method: "POST",
      data: {
        obs_privadas: $modalWrapper.find("input[name=obs_privadas]").val(),
      },
      url:
        $(".modalAreaClienteEncomendaObsPrivadas form").attr("action") +
        "?hash=" +
        new Date().getTime(),
      dataType: "json",
    })
      .done(function (result) {
        console.log(result);

        if (Number(result.status) == "1") {
          window.location.reload();
        } else {
          alert("Ocorreu um erro, por favor contacte o Administrador.");
        }
      })
      .fail(function (result) {
        console.log("failed");
      });
  });

  $(".modal-support-window-close").click(function () {
    //$('.modal-support-window').hide();
    $(".modal-support-window").removeClass("modal-support-window__move");
    //$('.modal-support-icon').show();
    $(".modal-support-icon-wrapper").removeClass(
      "modal-support-icon-wrapper__move"
    );

    sessionStorage.setItem("support-window-autoshow", true);

    return false;
  });

  $(".modal-support-window form").submit(function () {
    $modalWrapper = $(".modal-support-window form");

    $.post(
      $(this).attr("action") + "?hash=" + new Date().getTime(),
      {
        name: $modalWrapper.find(".name").val(),
        phone: $modalWrapper.find(".phone").val(),
      },
      function (result) {
        if (result == "sucesso") {
          $(".modal-support-window .alert-success").show();
          $modalWrapper.find(".name").val("");
          $modalWrapper.find(".phone").val("");
        } else {
          alert("Ocorreu um erro, por favor contacte o Administrador.");
        }
      }
    );

    sessionStorage.setItem("support-window-autoshow", true);

    return false;
  });

  $(".encomendas-mbway-form").submit(function (e) {
    e.preventDefault();

    $(".msg-operation").hide();

    var url = $(this).attr("action");

    $.ajax({
      context: this,
      method: "POST",
      data: {
        phone: $("input[name=phone]").val().trim(),
      },
      url: url + "?" + new Date().getTime(),
      dataType: "json",
    })
      .done(function (result) {
        if (result.status == "000") {
          $(".msg-operation")
            .html(
              "Pedido de pagamento efectuado.<br />Verifique o seu telemóvel."
            )
            .show();
        }
      })
      .fail(function (result) {
        alert(result);
      });
  });

  //Normal é ser 5000
  if (
    !sessionStorage.getItem("support-window-autoshow") ||
    sessionStorage.getItem("support-window-autoshow") === false
  ) {
    setTimeout(function () {
      //$('.modal-support-window').show();
      $(".modal-support-window").addClass("modal-support-window__move");
      //$('.modal-support-icon').hide();
      $(".modal-support-icon-wrapper").addClass(
        "modal-support-icon-wrapper__move"
      );
      $(".modal-support-window .alert-success").hide();
    }, 5000);
  }

  if (
    !sessionStorage.getItem("eucookie") ||
    sessionStorage.getItem("eucookie") === false
  ) {
    $(".eupopup-markup-container").show();

    $(".eupopup-closebutton").click(function () {
      sessionStorage.setItem("eucookie", true);
      $(".eupopup-markup-container").hide();
      return false;
    });
  }
});


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// main.js